// Модуль «Рейсы»: /api/v2/trips-board/* (erp-backend, модуль src/trips_board). [Claude, 04.11.2026]
import { useAxiosCreate } from '@/backend/utils.js'
import { downloadBlobResponse } from '@/backend/download'

const api = useAxiosCreate('api')

export async function fetchTripsBoard(params, { signal } = {}) {
  const { data } = await api.get('trips-board', { params, signal })
  return data
}

export async function fetchTripsMeta() {
  const { data } = await api.get('trips-board/meta')
  return data
}

export async function downloadTripsExcel(params) {
  const response = await api.get('trips-board/export', { params, responseType: 'blob' })
  const stamp = new Date().toISOString().slice(0, 16).replace(/[-:T]/g, '')
  await downloadBlobResponse(response, `trips_${stamp}.xlsx`)
}
